import dados from "./videos.json";

/**
 * Os vídeos publicados, lidos de videos.json.
 *
 * A lista mora em JSON porque quem a atualiza é o scripts/novo-video.sh,
 * no fim da produção de cada reel: editar JSON é seguro, editar TypeScript
 * com script é como quebra.
 *
 * A capa de cada um é a thumb real que foi para o Instagram, e a prévia é
 * um trecho mudo de 4s. É de propósito que a página não tenha cor própria:
 * a cor vem do trabalho, e o papel fica neutro atrás dele.
 */

export interface Video {
  slug: string;
  titulo: string;
  /** A ideia em uma linha, do jeito que a pessoa procuraria no Google. */
  resumo: string;
  /** Texto maior, só para quando o vídeo está em destaque. */
  chamada?: string;
}

/** Do mais recente para o mais antigo. */
export const VIDEOS: readonly Video[] = dados.videos;

/** Quantos cabem na prateleira. O resto fica para a página de assuntos. */
export const NA_PRATELEIRA = 20;

/** A capa em 540px, usada como fallback e em tela de alta densidade. */
export const CAPA = (slug: string) => `/videos/${slug}.webp`;

/** As duas larguras disponíveis, para o navegador escolher a certa. */
export const CAPA_SRCSET = (slug: string) =>
  `/videos/${slug}@272.webp 272w, /videos/${slug}.webp 540w`;

/** O item nunca passa de 212px de largura (ver .jg-faixa-item). */
export const CAPA_SIZES = "(max-width: 540px) 40vw, 212px";

/** Trecho de 4s, mudo, ~40kB: dá para rodar vários ao mesmo tempo. */
export const PREVIA = (slug: string) => `/videos/${slug}-preview.mp4`;

const emDestaque =
  VIDEOS.find((v) => v.slug === dados.destaque) ?? VIDEOS[0];

if (!emDestaque) {
  throw new Error("videos.json está sem vídeos");
}

/** O vídeo que toca grande na home: 14s do mais recente, também mudo. */
export const DESTAQUE = {
  slug: emDestaque.slug,
  src: `/videos/destaque-${emDestaque.slug}.mp4`,
  titulo: emDestaque.titulo,
  chamada: emDestaque.chamada ?? emDestaque.resumo,
} as const;
